<template>
  <div class="home">
    <div class="bg">
      <img class="item" src="@/assets/home/top.png" alt="">
      <div class="download">
        <div class="button">
          <div class="img"><img src="@/assets/home/download.png" alt=""></div>
          关注了解更多
        </div>
        <div class="qr"><img src="@/assets/home/qr.png" alt=""></div>
      </div>
      <div class="xia"><img src="@/assets/product/gif/xia.gif" alt=""></div>
    </div>
    <div class="idoru-project-scale">
      <div class="">
        <div class="title">
          <div class="top">爱多路重塑业主信任</div>
          <div class="bottom">
            <div class="line"></div>
            <div class="text">致力于将社区权利归还给业主</div>
            <div class="line"></div>
          </div>
        </div>
        <p>爱多路信息化管理平台以“统一领导、统一规划、统一开发”为原则，以最新的科学技术、优质稳定的产品为业务赋能，助力基层治理能力、自我管理能力、社区服务能力的提升</p>
        <div class="imgs">
          <div class="i wow animate__fadeInLeft animation-delay-300ms">
            <img src="@/assets/home/1-1.png" alt="">
            <div class="text">爱多路统一的财务收费系统，重新定义了物业收费的新模式，囊括了150+收费模板，满足所有的物业收费项目。</div>
          </div>
          <div class="i wow animate__fadeInUp animation-delay-300ms">
            <img src="@/assets/home/1-2.png" alt="">
            <div class="text">IDAS系统抓取了小区内的所有的收入/支出科目，并且实时计算小区的收益及预估支持项目，便于核对账目。</div>
          </div>
          <div class="i wow animate__fadeInRight animation-delay-300ms">
            <img src="@/assets/home/1-3.png" alt="">
            <div class="text">R计划打破了原有的物业服务模式，以酬金制的方式吸纳大量服务人员，以工单派发的方式服务社区，并受所有业主的监督。</div>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="title">
        <div class="top">资讯</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Journalism</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="news">
        <div class="left-bar">
          <div class="i" :class="{selected: selected === 0}" @click="selected = 0">
            <div class="name">社区居民</div>
            <div class="text">Resident</div>
          </div>
          <div class="i" :class="{selected: selected === 1}" @click="selected = 1">
            <div class="name">智慧社区</div>
            <div class="text">Wisdom</div>
          </div>
          <div class="i" :class="{selected: selected === 2}" @click="selected = 2">
            <div class="name">智慧数据</div>
            <div class="text">Analysis</div>
          </div>
        </div>
        <div class="right animate__animated animate__fadeIn" v-show="selected === 0">
          <div class="i all" @click="goHref('https://mp.weixin.qq.com/mp/homepage?__biz=MzUyNDg1OTc2Ng==&module=shop&hid=2&sn=30f686f9033bcfc90a8e2affc7126183&operationTitle=%E7%88%B1%E5%A4%9A%E8%B7%AF&houseId=47643&uin=MjM4MDQ3MzYwMQ%253D%253D&key=ecfb48521916481b2f8506de72417a29c4734e71512e7ab55d5adc65c10ec7daaa56e8c04bfd312378dc948c8978f415c3ad0121e565b4151df505cbf9fda3b42b90565b88a19ecdf8f208f4131af135&devicetype=iMac+MacBookPro13%252C1+OSX+OSX+10.15.5+build(19F101)&version=12040110&lang=zh_CN&nettype=WIFI&ascene=1&fontScale=100&pass_ticket=BTJWnprfowZumxr2ekE%252B55HzPr60KUQGKpNAz5PABtJevVjzSZAyNg3RKxva9rE5')">查看全部<div class="icon"><img src="@/assets/home/all.png" alt=""></div></div>
          <div class="i half" @click="goHref('https://mp.weixin.qq.com/s/bJIzvaCcMbvNITyEtH1Wow')">
            <img src="@/assets/home/img2.png" alt="">
            <div class="pop">
              <div class="text">爱多路以人为本开启物业新未来</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="i half" @click="goHref('https://mp.weixin.qq.com/s?__biz=MzUyNDg1OTc2Ng==&amp;mid=2247484246&amp;idx=1&amp;sn=abd496523b0f5cbbc06027eb0e9c6bf4&amp;chksm=fa27a34fcd502a59f7613b28c12a6c37d7ac438726e53150def7e85e165a1fce1acecf13b026&token=182054518&lang=zh_CN#wechat_redirect')">
            <img src="@/assets/home/img8.png" alt="">
            <div class="pop">
              <div class="text">观点 | 谁推倒了物业公司？</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="i" @click="goHref('https://mp.weixin.qq.com/s/Busba6KlLfa95XU4RYRKKA')">
            <img src="@/assets/home/img3.png" alt="">
            <div class="pop">
              <div class="text">男子高空抛物，物业对该户断电30天！你怎么看？</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right animate__animated animate__fadeIn" v-show="selected === 1">
          <div class="i all" @click="goHref('https://mp.weixin.qq.com/mp/homepage?__biz=MzUyNDg1OTc2Ng==&module=shop&hid=2&sn=30f686f9033bcfc90a8e2affc7126183&operationTitle=%E7%88%B1%E5%A4%9A%E8%B7%AF&houseId=47643&uin=MjM4MDQ3MzYwMQ%253D%253D&key=ecfb48521916481b2f8506de72417a29c4734e71512e7ab55d5adc65c10ec7daaa56e8c04bfd312378dc948c8978f415c3ad0121e565b4151df505cbf9fda3b42b90565b88a19ecdf8f208f4131af135&devicetype=iMac+MacBookPro13%252C1+OSX+OSX+10.15.5+build(19F101)&version=12040110&lang=zh_CN&nettype=WIFI&ascene=1&fontScale=100&pass_ticket=BTJWnprfowZumxr2ekE%252B55HzPr60KUQGKpNAz5PABtJevVjzSZAyNg3RKxva9rE5')">查看全部<div class="icon"><img src="@/assets/home/all.png" alt=""></div></div>
          <div class="i half" @click="goHref('https://mp.weixin.qq.com/s/hFllmQdx83OICVn_YZiPUw')">
            <img src="@/assets/home/img1.png" alt="">
            <div class="pop">
              <div class="text">体验过爱多路小区的智能化出行后，我想立刻搬！过！来！</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="i half" @click="goHref('https://mp.weixin.qq.com/s/VPALl6nwwSx0v8ME7wBL3A')">
            <img src="@/assets/home/img5.png" alt="">
            <div class="pop">
              <div class="text">房价一涨再涨，老百姓却乐开了花？！是的，你没听错....</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="i" @click="goHref('https://mp.weixin.qq.com/s/lZT2LqYbpFKVgxKNsAwwcA')">
            <img src="@/assets/home/img6.png" alt="">
            <div class="pop">
              <div class="text">走进社区心脏，只有1%的人才知晓的地方！</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right animate__animated animate__fadeIn" v-show="selected === 2">
          <div class="i all" @click="goHref('https://mp.weixin.qq.com/mp/homepage?__biz=MzUyNDg1OTc2Ng==&module=shop&hid=2&sn=30f686f9033bcfc90a8e2affc7126183&operationTitle=%E7%88%B1%E5%A4%9A%E8%B7%AF&houseId=47643&uin=MjM4MDQ3MzYwMQ%253D%253D&key=ecfb48521916481b2f8506de72417a29c4734e71512e7ab55d5adc65c10ec7daaa56e8c04bfd312378dc948c8978f415c3ad0121e565b4151df505cbf9fda3b42b90565b88a19ecdf8f208f4131af135&devicetype=iMac+MacBookPro13%252C1+OSX+OSX+10.15.5+build(19F101)&version=12040110&lang=zh_CN&nettype=WIFI&ascene=1&fontScale=100&pass_ticket=BTJWnprfowZumxr2ekE%252B55HzPr60KUQGKpNAz5PABtJevVjzSZAyNg3RKxva9rE5')">查看全部<div class="icon"><img src="@/assets/home/all.png" alt=""></div></div>
          <div class="i half" @click="goHref('https://mp.weixin.qq.com/s/tJR_yhqamFAaW6db3WXO6A')">
            <img src="@/assets/home/img4.png" alt="">
            <div class="pop">
              <div class="text">老树开新花”，专业技能赋予南田雅园焕新生</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="i half" @click="goHref('https://mp.weixin.qq.com/s/dSMV6z3qlSu5R1vxbFJSnQ')">
            <img src="@/assets/home/img8.png" alt="">
            <div class="pop">
              <div class="text">品牌战略升级，致力成为业主第一居所的首选品牌！</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="i" @click="goHref('https://mp.weixin.qq.com/s/nBG6xyR4WalrrUGX-O56QA')">
            <img src="@/assets/home/img9.png" alt="">
            <div class="pop">
              <div class="text">玺拓科技荣获“国家信息系统安全等级保护”三级认证</div>
              <div class="next">
                <div class="icon">
                  <img src="@/assets/home/next.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="title">
        <div class="top">成功案例</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Success stories</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="stories">
        <div class="next" @click="change('less')">
          <div class="icon left">
            <img src="@/assets/home/left.png" alt="">
          </div>
        </div>
        <div class="i" v-if="changed === 0">
          <div class="e">
            <div class="text">改造前</div>
            <img src="@/assets/home/stories/1.png" alt="">
          </div>
          <div class="e">
            <div class="text">改造后</div>
            <img src="@/assets/home/stories/2.png" alt="">
          </div>
          <div class="name">南田雅园</div>
        </div>
        <div class="i" v-if="changed === 1">
          <div class="e">
            <div class="text">改造前</div>
            <img src="@/assets/home/stories/3.png" alt="">
          </div>
          <div class="e">
            <div class="text">改造后</div>
            <img src="@/assets/home/stories/4.png" alt="">
          </div>
          <div class="name">南田雅园</div>
        </div>
        <div class="i" v-if="changed === 2">
          <div class="e">
            <div class="text">改造前</div>
            <img src="@/assets/home/stories/5.png" alt="">
          </div>
          <div class="e">
            <div class="text">改造后</div>
            <img src="@/assets/home/stories/6.png" alt="">
          </div>
          <div class="name">南田雅园</div>
        </div>
        <div class="i" v-if="changed === 3">
          <div class="e">
            <div class="text">改造前</div>
            <img src="@/assets/home/stories/7.png" alt="">
          </div>
          <div class="e">
            <div class="text">改造后</div>
            <img src="@/assets/home/stories/8.png" alt="">
          </div>
          <div class="name">南田雅园</div>
        </div>
        <div class="i" v-if="changed === 4">
          <div class="e">
            <div class="text">改造前</div>
            <img src="@/assets/home/stories/9.png" alt="">
          </div>
          <div class="e">
            <div class="text">改造后</div>
            <img src="@/assets/home/stories/10.png" alt="">
          </div>
          <div class="name">南田雅园</div>
        </div>
        <div class="next" @click="change('add')">
          <div class="icon right">
            <img src="@/assets/home/right.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="title">
        <div class="top">核心技术</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">core technology</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="technology">
        <div class="i wow animate__fadeInLeft animation-delay-300ms" @click.stop="navigation({name: 'Product', query: {selected: 0}})">
          <img src="@/assets/home/chanpin.png" alt="">
          <div class="text">R计划灵活用工系统</div>
        </div>
        <div class="i wow animate__fadeInUp animation-delay-300ms" @click.stop="navigation({name: 'Product', query: {selected: 1}})">
          <img src="@/assets/home/zhongtai.png" alt="">
          <div class="text">iDAS财务预警系统</div>
        </div>
        <div class="i wow animate__fadeInRight animation-delay-300ms" @click.stop="navigation({name: 'Product', query: {selected: 2}})">
          <img src="@/assets/home/yanfa.png" alt="">
          <div class="text">软硬件一体化平台</div>
        </div>
      </div>
    </div>
    <div class="modules-bg">
      <div class="modules wow animate__fadeIn animation-delay-500ms">
        <div class="i">
          <img src="@/assets/home/6-1.png" alt="">
          <div class="label">
            <div class="subtitle">
              <div class="name">财务公示</div>
              <div class="en">Financial publicity</div>
            </div>
            <div class="text">小区财务全公开，收入全透明，提供银行对账单级别“准确度”的财务公示（秒级更新）。</div>
            <div class="list">
              <div class="e"><div class="r"></div>财务规范</div>
              <div class="e"><div class="r"></div>单据正规</div>
              <div class="e"><div class="r"></div>财务清晰</div>
              <div class="e"><div class="r"></div>数据真实</div>
            </div>
          </div>
        </div>
        <div class="i">
          <img src="@/assets/home/6-2.png" alt="">
          <div class="label">
            <div class="subtitle">
              <div class="name">投票决策</div>
              <div class="en">Voting decision</div>
            </div>
            <div class="text">业主参与小区管理，自主选择、推荐、监督、人人参与，打造阳光社区。</div>
          </div>
        </div>
        <div style="width: 100%"></div>
        <div class="i">
          <div class="label">
            <div class="subtitle">
              <div class="name">服务竞标</div>
              <div class="en">Service bidding</div>
            </div>
            <div class="text">业主可投票选出自己满意的专业服务商，参与社区的物业管理事务，来行使业主的权力。</div>
          </div>
          <img src="@/assets/home/6-3.png" alt="">
        </div>
        <div class="i">
          <div class="label">
            <div class="subtitle">
              <div class="name">智能门禁</div>
              <div class="en">Intelligent access control</div>
            </div>
            <div class="text">智能门禁系统，是以人脸识别技术为核心，对人的脸部特征信息进行身份认证的识别技术，让我们的居住环境更安全、更智能。</div>
          </div>
          <img src="@/assets/home/6-4.png" alt="">
        </div>
      </div>
    </div>
    <!-- <div class="">
      <div class="title">
        <div class="top">入驻企业</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Settled Enterprise</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="enterprise">
        <img src="@/assets/home/bottom.png" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
import { WOW } from 'wowjs'
export default {
  name: 'Home',
  components: {

  },
  data () {
    return {
      selected: 0,
      changed: 0
    }
  },
  mounted () {
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animate__animated',
      offset: 0,
      mobile: true
    })
    wow.init()
  },
  methods: {
    /**
     * 页面跳转
     */
    navigation (url) {
      this.$router.push(url)
    },
    change (e) {
      if (e === 'less') {
        if (this.changed > 0) {
          this.changed--
        } else {
          this.changed = 4
        }
      }
      if (e === 'add') {
        if (this.changed < 4) {
          this.changed++
        } else {
          this.changed = 0
        }
      }
    },
    goHref (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
.bg {
  position: relative;
}
.bg .download {
  position: absolute;
  z-index: 2;
  bottom: 15rem;
  width: 40rem;
  left: calc(50% - 20rem);
  font-size: 2rem;
  color: #FFFFFF;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}
.bg .xia {
  position: absolute;
  z-index: 2;
  bottom: 1rem;
  width: 2.4rem;
  left: calc(50% - 1.2rem);
  opacity: 0.8;
}
.bg .download .button {
  padding-left: 20rem;
  white-space: nowrap;
  transition: all 0.5s;
}
.bg .download .img {
  width: 3rem;
  padding-bottom: 2rem;
  margin: 0 auto;
}
.bg .download .qr {
  width: 20rem;
  min-width: 20rem;
  margin-left: 0.5rem;
  opacity: 0;
  transition: all 0.2s;
}
.bg .download:hover .button {
  padding-left: 0;
}
.bg .download:hover .qr {
  opacity: 1;
}
.item {
  height: 100vh;
  background-color: #FFFFFF;
}
.idoru-project-scale {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  padding: 7.5rem 0;
  background-color: #FFFFFF;
}
.title .top {
  font-size: 2.6rem;
  line-height: 5.4rem;
  font-weight: bolder;
  color: #FF8C33;
}
.title .bottom {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title .line {
  width: 30rem;
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #CECECE;
}
.title .text {
  font-size: 2.6rem;
  font-weight: bolder;
  color: #E7E6E6;
  margin: 0 2rem;
  text-transform: uppercase;
}
.title .text span {
  text-transform: lowercase;
}
p {
  margin-top: 6.5rem;
  margin-bottom: 13rem;
  font-size: 1.4rem;
  color: #434343;
}
.imgs {
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgs .i {
  width: 28.4rem;
}
.imgs .i + .i {
  margin-left: 20rem;
}
.imgs .i .text {
  font-size: 2rem;
  color: #999999;
  margin: 8.5rem 0;
}
.news {
  background-color: #414651;
  padding: 4.5rem 0;
  display: flex;
  justify-content: center;
  font-style: oblique;
}
.news .left-bar {
  width: 20rem;
}
.news .right {
  color: #E4E4E4;
  width: 100rem;
  margin-left: 15rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.news .left-bar .i {
  border-left: 0.3rem solid transparent;
  color: #FFFFFF;
  font-size: 2.6rem;
  font-weight: bolder;
  margin-top: 10rem;
  transition: all 0.2s;
}
.news .left-bar .i:first-child {
  margin-top: 4.8rem;
}
.news .left-bar .i .text {
  color: #FEFEFE;
  font-size: 2.6rem;
  opacity: 0;
  transition: all 0.2s;
}
.news .left-bar .i.selected {
  border-color: #FF903A;
  color: #FF903A;
  font-size: 4rem;
}
.news .left-bar .i.selected .text {
  opacity: 0.38;
}
.news .right .all {
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 4.8rem;
  font-style: normal;
}
.news .right .all .icon {
  width: 0.6rem;
  margin-left: 1rem;
}
.news .right .i {
  width: 100%;
  position: relative;
}
.news .right .i:last-child {
  margin-top: 4rem;
}
.news .right .half {
  width: calc(50% - 2rem);
}
.news .right .pop {
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-size: 1.4rem;
  text-align: left;
  padding: 2rem;
  box-sizing: border-box;
  font-weight: bold;
  transition: all 0.1s;
}
.news .right .pop .next {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  border-radius: 50%;
  border: 0.2rem solid transparent;
  transition: all 0.1s;
  margin-left: 2rem;
  padding: 0.1rem;
}
.news .right .pop .next .icon {
  width: 1.5rem;
  min-width: 1.5rem;
}
.news .right .i:hover .pop {
  font-size: 2rem;
}
.news .right .i:hover .pop .next {
  border-color: #FFFFFF;
  padding: 1rem;
}
.stories {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 8rem;
}
.stories .next {
  width: 6rem;
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.3rem solid transparent;
  border-radius: 50%;
  margin: 0 5rem;
}
.stories .next:hover {
  border-color: #000000;
}
.stories .next .icon {
  width: 1.6rem;
}
.stories .next .left {
  padding-right: 0.5rem;
}
.stories .next .right {
  padding-left: 0.5rem;
}
.stories .i {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.stories .i .e img {
  width: 40rem;
  height: 49rem;
}
.stories .i .e .text {
  font-size: 1.8rem;
  font-weight: bolder;
  padding: 4rem 0 2rem 0;
}
.stories .i .name {
  width: 100%;
  color: #000000;
  font-size: 2.6rem;
  font-weight: bolder;
  padding: 8rem 0 0 0;
  box-sizing: border-box;
}
.technology {
  display: flex;
  align-items: center;
  justify-content: center;
}
.technology .i {
  width: 27.5rem;
}
.technology .i + .i {
  margin-left: 24rem;
}
.technology .i .text {
  color: #434343;
  font-size: 2.6rem;
  margin: 6.5rem 0;
  font-weight: bolder;
}
.modules-bg {
  background-color: #414651;
}
.modules {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 2rem;
  padding-bottom: 10rem;
}
.modules .i {
  display: flex;
  color: #FFFFFF;
  text-align: left;
  padding-top: 10rem;
}
.modules .i + .i {
  margin-left: 10rem;
}
.modules .i img {
  width: 20rem;
}
.modules .i .label {
  width: 30rem;
}
.modules .i .subtitle {
  border-left: 0.4rem solid #FF8C33;
  padding-left: 1.5rem;
  font-weight: bolder;
  margin-top: 5rem;
}
.modules .i .subtitle .name {
  color: #FF8C33;
  font-size: 2.8rem;
}
.modules .i .subtitle .en {
  font-size: 1.6rem;
  color: #E7E6E6;
  text-transform: uppercase;
}
.modules .i .text {
  padding-top: 3rem;
  font-size: 1.4rem;
  line-height: 4rem;
}
.modules .i .list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.modules .i .list .e {
  display: flex;
  align-items: center;
  padding-right: 5rem;
  font-size: 1.4rem;
  line-height: 3.6rem;
  box-sizing: border-box;
}
.modules .i .list .e .r {
  width: 0.8rem;
  height: 0.8rem;
  background-color: #FF8C33;
  border-radius: 50%;
  margin-right: 1rem;
}
.enterprise {
  max-width: 120rem;
  padding-bottom: 5rem;
  margin: 0 auto;
}
</style>
